/* eslint-disable @angular-eslint/directive-class-suffix */
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Directive, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
export interface ICurrentLocaleComponent {
  crtLocale: string;
}

@Directive()
export abstract class CurrentLocaleComponent
  implements ICurrentLocaleComponent, OnInit, OnDestroy
{
  crtLocale: string;

  private langChangeSubscription: Subscription;

  constructor(protected readonly translate: TranslateService) {}

  ngOnInit(): void {
    this.langChangeSubscription = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.crtLocale = event.lang;
      }
    );
    this.crtLocale = this.translate.currentLang;
  }

  ngOnDestroy(): void {
    this.langChangeSubscription.unsubscribe();
  }
}
